import { create } from "zustand";
import { persist } from "zustand/middleware";

import { IacManagementGroupBy } from "../types";
import { IacManagementStore } from "./types";

type MakeIacManagementStoreProps = {
  storageKey: string;
  parentStackId?: string;
};

type PersistedState = {
  groupBy: IacManagementGroupBy;
};

const makeIacManagementStore = ({ storageKey, parentStackId }: MakeIacManagementStoreProps) =>
  create<IacManagementStore>()(
    persist(
      (set) => ({
        groupBy: parentStackId ? IacManagementGroupBy.None : IacManagementGroupBy.Stack,
        setGroupBy: (groupBy) => set({ groupBy }),
        allItemsQty: 0,
        setAllItemsQty: (allItemsQty) => set({ allItemsQty }),
        allResourcesQty: 0,
        setAllResourcesQty: (allResourcesQty) => set({ allResourcesQty }),
        pageIsEmpty: false,
        setPageIsEmpty: (pageIsEmpty) => set({ pageIsEmpty }),
        parentStackId,
      }),
      {
        name: storageKey,
        partialize: (state) => ({
          groupBy: state.groupBy,
        }),
        version: 1,
        migrate: (persistedState: unknown): PersistedState => {
          const state = persistedState as Partial<PersistedState>;

          // If we have a parentStackId and the stored groupBy is Stack, change it to None
          if (parentStackId && state?.groupBy === IacManagementGroupBy.Stack) {
            return {
              groupBy: IacManagementGroupBy.None,
            };
          }

          return state as PersistedState;
        },
      }
    )
  );

export default makeIacManagementStore;
